import TextButtonWithDocumentation from "./TextButtonDocumentation";
import React from "react";
import {
    withStyles,
    Menu,
    Button,
    MenuItem,
    Popover,
    Typography,
} from "@material-ui/core";
import {
    usePopupState,
    bindTrigger,
    bindPopover,
} from "material-ui-popup-state/hooks";
import bounceDoc from "./BounceDocumentation";
import breakDoc from "./BreakDocumentation";
import adHocDoc from "./AdHocDocumenation";
import BounceEmaDoc from "./BounceEmaDocumentation";
import BreakEmaDoc from "./BreakEmaDocumentation";
import CandleTriggerDoc from "./CandleTriggerDocumentation";
import FlagDoc from "./FlagDoc";
import ConvictionCandleDoc from "./ConvictionCandleDocumenation";
import FTFCDocs from "./FtfcDocumentation";
import CandleBreakTypeDocs from "./CandleBreakTypeDocs";
import CandlePatternDocumentation from "./CandlePatternDocumentation";
import OrbDocs from "./OrbDocumentation";

export default function SetupDocs() {
    const popupState = usePopupState({
        variant: "popover",
        popupId: "setupMenu",
    });
    return (
        <>
            <Button {...bindTrigger(popupState)}>
                {<Typography style={{fontSize: 12}}>setups</Typography>}
            </Button>
            <Popover
                {...bindPopover(popupState)}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                }}
            >
                &nbsp;&nbsp;&nbsp;&nbsp;docs:
                <TextButtonWithDocumentation label="Bounce" doc={bounceDoc}/>
                <TextButtonWithDocumentation label="Break" doc={breakDoc}/>
                <TextButtonWithDocumentation label="AdHoc" doc={adHocDoc}/>
                <TextButtonWithDocumentation
                    label="CONVICTION_CANDLE"
                    doc={ConvictionCandleDoc}
                />
                <TextButtonWithDocumentation label="Bounce Ema" doc={BounceEmaDoc}/>
                <TextButtonWithDocumentation label="Break Ema" doc={BreakEmaDoc}/>
                <TextButtonWithDocumentation
                    label="Candle Trigger"
                    doc={CandleTriggerDoc}
                />
                <TextButtonWithDocumentation label="Flag" doc={FlagDoc}/>
                <TextButtonWithDocumentation label="FTFC" doc={FTFCDocs}/>
                <TextButtonWithDocumentation label="Candle Pattern" doc={CandlePatternDocumentation}/>
                <TextButtonWithDocumentation label="ORB" doc={OrbDocs}/>
            </Popover>
        </>
    );
}

export const getSetupDoc = (setup) => {
    switch (setup) {
        case "Bounce":
        case "BOUNCE":
            return bounceDoc;
        case "Break":
        case "BREAK":
            return breakDoc;
        case "Ad Hoc":
        case "AD_HOC":
            return adHocDoc;
        case "CONVICTION_CANDLE":
        case "Conviction Candle":
            return ConvictionCandleDoc;
        case "Bounce Ema":
        case "BOUNCE_EMA":
            return BounceEmaDoc;
        case "Break Ema":
        case "BREAK_EMA":
            return BreakEmaDoc;
        case "Candle Trigger":
        case "CANDLE_TRIGGER":
            return CandleTriggerDoc;
        case "Flag":
        case "FLAG":
            return FlagDoc;
        case "FTFC":
        case "FTFC (The Strat)":
            return FTFCDocs;
        case "Break Candle Type":
        case "BREAK_CANDLE_TYPE":
            return CandleBreakTypeDocs;
        case "CANDLE_PATTERN":
        case "Candle Pattern":
            return CandlePatternDocumentation;
        case "ORB":
            return OrbDocs;
        default:
            console.log(setup);
    }
};
